import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Grid, Navbar, Jumbotron, Button, NavDropdown, NavItem, MenuItem, Nav } from 'react-bootstrap';
import { chunks } from '../container/App';


class ProductRows extends React.Component {
    render() {
        const name = this.props.product.name;
        const link = name + ".html";
        return (
            <a href={link} className="dropdown-item" tabIndex="-1" >{name}</a >
        );
    }
}

class ProductTable extends React.Component {
    render() {
        const rows = chunks(this.props.products, 8);
        var count = 0;
        var html = rows.map((row) => (
            <div className="col-lg-3 dropdown-icons-default" key={count++}>
                {/*<h3 className="dropdown-header mb-0">{count}</h3>*/}
                {
                    row.map((product) => (
                        <ProductRows product={product} key={product.name} />
                    ))
                }
            </div>
        ));
        return (
            <div className="row">{html}</div>
        )
    }
}

export default class Navmenu extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            // open: true 
            open: true   // !!!
        };
    }



    render() {
        const translationTextHome = { en: "Home", chi: "主頁" }
        const translationTextBrand = { en: "Brands", chi: "品牌" }
        const translationTextProduct = { en: "Product", chi: "產品" }
        const translationTextAboutUs = { en: "About Us", chi: "關於我們" }
        const translationTextContactUs = { en: "Contact Us", chi: "聯繫我們" }

        var navLinkFontStyle = {
            fontSize: '18px'
        }

        return (
            <div className="navbar navbar-toggleable-md">
                {/*<!--everything within this div is collapsed on mobile-->*/}
                <div className="navbar-main collapse bg-grey-dark navbar-inverse">
                    <div className="container clearfix">
                        {/*<!--main navigation-->*/}
                        <ul className="nav navbar-nav float-lg-left navbar-nav-flush dropdown-effect-fadeup">
                            {/*<!-- Shop Homepage -->*/}
                            <li className="nav-item"> <NavLink strict to="/" className="nav-link" style={navLinkFontStyle}>{translationTextHome[this.props.language]}</NavLink> </li>

                            {/*<li className="nav-item dropdown dropdown-mega-menu dropdown-persist active" >
                                <a className="nav-link dropdown-toggle" id="shop-mega-menu" data-hover="dropdown" data-toggle="dropdown" data-hover="dropdown">Brand</a>
                                <div className="dropdown-menu dropdown-menu-right dropdown-menu-nobullets" aria-labelledby="shop-mega-menu">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <ProductTable products={this.props.products} />
                                        </div>
                                    </div>
                                </div>
                            </li>*/}
                            <li className="nav-item">  <NavLink to='/brands' className="nav-link" style={navLinkFontStyle}>{translationTextBrand[this.props.language]}</NavLink></li>
                            <li className="nav-item">  <NavLink to='/products' className="nav-link" style={navLinkFontStyle}>{translationTextProduct[this.props.language]}</NavLink></li>

                            {/*<!-- Shop Pages -->*/}
                            {/*<li className="nav-item dropdown">*/}
                            {/*<a className="nav-link dropdown-toggle" id="pages-drop" data-toggle="dropdown" data-hover="dropdown">Shop Pages</a>*/}
                            {/*<div className="dropdown-menu"> <a href="shop-grid.htm" className="dropdown-item">Brands</a> <a href="shop-list.htm" className="dropdown-item">Products List</a> <a href="shop-product.htm" className="dropdown-item">Product View</a> <a href="shop-cart.htm" className="dropdown-item">Cart</a> <a href="shop-checkout.htm" className="dropdown-item">Checkout</a> <a href="shop-confirmation.htm" className="dropdown-item">Confirmation</a> </div>*/}
                            {/*</li>*/}

                            <li className="nav-item">  <NavLink to='/about' className="nav-link" style={navLinkFontStyle}>{translationTextAboutUs[this.props.language]}</NavLink></li>
                            <li className="nav-item"> <Link to='/contact' className="nav-link" style={navLinkFontStyle}>{translationTextContactUs[this.props.language]}</Link></li>
                        </ul>
                    </div>
                </div>
                {/*<!--/.navbar-collapse -->*/}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/Navmenu.js